import homeReducer from './reducers';
export { default as homeOperations } from './operations';
export { default as homeTypes } from './types';
export default homeReducer;